import { Outlet } from "react-router-dom";
import { useEffect } from "react";
import { useSelector,useDispatch } from "react-redux";


import { clicksService } from "../../../../App";
import { clearClicks } from "../../../../slice/clicksSlice";

const Layout = () => {
  // @ts-ignore
  const clicks = useSelector((state) => state.clicks.value);
  const dispatch = useDispatch();

  useEffect(() => {
    // flush clicks to server every 5 minutes
    const intervalId = setInterval(() => {
      //console.log(JSON.stringify(clicks));
      if (clicks.length > 0) {
        //console.log("clicks processing");
        clicksService.sendClicks(clicks).then(() => {
          //console.log("clicks sent");
          dispatch(clearClicks())
        });
      }
    }, 1000 * 60 * 5); // 5 minutes

    // Cleanup the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, [clicks]); 

  return (
    <>
      <Outlet />
    </>
  );
};

export default Layout;
